import { ReactElement } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../redux/store';
import { eventActions } from '../../redux/slices/event.slice';
import { ITeam } from '../../types/@team';
import { EEventCreateSteps } from '../../types/@event';

interface IProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const EventCreateTeam = ({ setStep }: IProps): ReactElement => {
  const dispatch = useDispatch();
  const teams = useSelector((state: RootState) => state.teams.all);

  const handleSelect = (team: ITeam): void => {
    dispatch(eventActions.selectedTeam(team));
    setStep(EEventCreateSteps.event);
  };

  const handleBack = (): void => {
    setStep(EEventCreateSteps.organisation);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '920px', margin: '0 auto', padding: '48px 24px' }}>
      <Typography sx={{ fontSize: '32px', fontWeight: 700, marginBottom: '24px' }}>
        Select team
      </Typography>

      <Box sx={{ display: 'grid', gap: '16px' }}>
        {teams.map((team: ITeam) => (
          <Box
            key={team._id}
            sx={{
              border: '1px solid #ddd',
              borderRadius: '12px',
              padding: '20px',
              cursor: 'pointer',
            }}
            onClick={() => handleSelect(team)}
          >
            <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>{team.name}</Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px' }}>
        <Button onClick={handleBack}>Back</Button>
      </Box>
    </Box>
  );
};

export default EventCreateTeam;